import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles(() => ({
  listWrapper: {
    height: '100%',
  },
}));
